import { AcceptedFile } from '@components/form-components/FileUploadField/interfaces';

export const appendFormData = (
  formData: FormData,
  value: unknown,
  key: string
): void => {
  if (value === undefined) {
    return;
  }

  if (value === null) {
    formData.append(key, '');
    return;
  }

  if (value instanceof File || value instanceof Blob) {
    formData.append(key, value);
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item, index) =>
      appendFormData(formData, item, `${key}[${index}]`)
    );
    return;
  }

  if (typeof value === 'object') {
    Object.entries(value).forEach(([childKey, childValue]) =>
      appendFormData(formData, childValue, `${key}[${childKey}]`)
    );
    return;
  }

  formData.append(key, String(value));
};

export const convertObjectToFormData = (
  object: Record<string, unknown>,
  method?: 'post' | 'put' | 'delete'
): FormData => {
  const formData = new FormData();

  Object.entries(object).forEach(([key, value]) => {
    appendFormData(formData, value, key);
  });

  if (method && method !== 'post') {
    formData.append('_method', method.toUpperCase());
  }

  return formData;
};

const isAcceptedFile = (item: any): item is AcceptedFile => {
  return (
    item &&
    typeof item === 'object' &&
    'file' in item &&
    item.file instanceof File
  );
};
